import React,{ useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {  useSelector  } from 'react-redux';
import {
  makeStyles,
  Container,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { NAVIGATION_DRAWER_WIDTH } from '../utils/const';
import { objectiveLicences } from '../reducers/licencesSlice';
import { redirectURL } from '../reducers/redirectURLSlice';
import Header from './Header/Header';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh'
  }
});

const MissingLicenceWarning = props => {
  const theme = useTheme();
  const classes = useStyles();
  const { t } = useTranslation();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));
  const [ drawerOpen, setDrawerOpen ] = useState(false);
  const hasValidLicence =  useSelector(objectiveLicences);
  const url = useSelector(redirectURL);

  useEffect(() => {
    if (hasValidLicence) props.history.push(url);
  },[ hasValidLicence, props, url ]);

  return (
    <>
      <Header drawerOpen={ drawerOpen } setDrawerOpen={ setDrawerOpen }/>
      <div style={ {
        marginLeft: !sm ? 'auto' : drawerOpen ? `${NAVIGATION_DRAWER_WIDTH}px` : '55px'
      } }>
        <Container maxWidth='xl' className={ classes.container }>
          <Typography variant='h3'>{t('objective.licence.missing')}</Typography>
        </Container>
      </div>
    </>
  );
};

export default MissingLicenceWarning;
